import type { SVGProps } from 'react';
const SvgFavoritesFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 32 32" {...props}>
    <path fill="currentColor" d="m16 23.693 8.24 4.974-2.187-9.374 7.28-6.306-9.586-.814L16 3.333l-3.747 8.84-9.586.814 7.28 6.306-2.187 9.374z" />
  </svg>
);
export default SvgFavoritesFilled;
